import { menuData } from "@/data/menuData";
import PageSeo from "@/components/PageSeo";

const MenuPage = () => {
  const menuJsonLd = {
    "@context": "https://schema.org",
    "@type": "Menu",
    name: "Getränkekarte Luther Club Kaiserslautern",
    hasMenuSection: menuData.map((category) => ({
      "@type": "MenuSection",
      name: category.title,
      hasMenuItem: category.items.map((item) => ({
        "@type": "MenuItem",
        name: item.name,
        ...(item.description ? { description: item.description } : {}),
      })),
    })),
  };

  return (
    <div className="pt-20">
      <PageSeo
        title="Getränkekarte – Luther Club Kaiserslautern"
        description="Unsere Getränkekarte: Cocktails, Spirituosen, Bier, Wein und alkoholfreie Drinks im Luther Club Kaiserslautern."
        path="/menu"
        jsonLd={menuJsonLd}
      />
      {/* Hero */}
      <div className="relative py-20 px-4 text-center">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(184,164,76,0.06)_0%,_transparent_70%)]" />
        <h1 className="relative text-4xl md:text-5xl font-bold text-primary mb-3">
          Getränkekarte
        </h1>
        <p className="relative text-lg text-foreground/70 italic">
          Hier findet ihr unser gesamtes Sortiment!
        </p>
      </div>

      {/* Menu Categories */}
      <div className="max-w-5xl mx-auto px-4 pb-24 space-y-20">
        {menuData.map((category) => (
          <div key={category.title}>
            <h2 className="text-2xl md:text-3xl font-semibold text-primary text-center mb-10 tracking-[0.15em]">
              {category.title}
            </h2>

            {category.image ? (
              <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                <div className="grid sm:grid-cols-2 gap-x-12 gap-y-6 flex-1">
                  {category.items.map((item, idx) => (
                    <div key={`${item.name}-${idx}`} className="border-b border-border/20 pb-4">
                      <h3 className="font-[Montserrat] text-sm tracking-[0.08em] uppercase text-foreground font-medium">
                        {item.name}
                      </h3>
                      {item.description && (
                        <p className="text-sm text-primary/70 mt-1">{item.description}</p>
                      )}
                    </div>
                  ))}
                </div>
                <div className="w-full md:w-72 lg:w-80 shrink-0">
                  <img src={category.image} alt={category.title} className="w-full h-auto rounded border border-border/40 object-cover sticky top-24" />
                </div>
              </div>
            ) : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-6">
                {category.items.map((item, idx) => (
                  <div key={`${item.name}-${idx}`} className="border-b border-border/20 pb-4">
                    <h3 className="font-[Montserrat] text-sm tracking-[0.08em] uppercase text-foreground font-medium">
                      {item.name}
                    </h3>
                    {item.description && (
                      <p className="text-sm text-primary/70 mt-1">{item.description}</p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuPage;
